<template>
     <span>
        <div  class="layui-unselect layui-form-select" :class="{'layui-form-selected': zqSelectShow && enabled}">
            <div class="layui-select-title" @click.stop="zqSelectShow = !zqSelectShow">
                <input type="text" :placeholder="placeholder" readonly="" class="layui-input" v-model="zqSelectText" :disabled="!enabled" :class="{'layui-disabled':!enabled}">
                <i @click.stop="clearWithModel()" class="layui-icon layui-unselect layui-tab-close" style="cursor: pointer;position: absolute;right: 25px;top: 50%; margin-top: -10px;color:#CCCCCC;">ဆ</i>
                <i class="layui-edge" style="top: 50%;"></i>
            </div>
            <dl style="padding: 0px; max-height: 300px;display:block;overflow-y: hidden;" class="zqdrop" v-show="zqSelectShow && enabled">
                <div class="layui-tab" style="margin:initial;">
                    <ul class="layui-tab-title">
                        <li style="min-width: 65px;"
                          v-for="(selectData, index) in selectDatas"
                          v-bind:key="selectData.id + selectData.text"
                          v-text="selectData.text"
                          @click.stop="setActiveTab(selectData);checkSelectDataIsLoad(index)"
                          :class="{'layui-this': selectData._tabActive}"></li>
                    </ul>
                    <div style="padding:initial;">
                        <div class="layui-tab-item" :class="{'layui-show': selectDatas[0] && selectDatas[0]._tabActive}">
                            <dl class="layui-anim layui-anim-upbit layui-zq-select-dl" style="display: block">
                                <dd v-for="item in dataMap[0]" v-bind:key="item.id+item.text" v-text="item.title" @click.stop="setSelectAndloadChildren(item, 0)" :class="{'layui-this': item._selected}"></dd>
                            </dl>
                        </div>
                        <div class="layui-tab-item" :class="{'layui-show': selectDatas[1] && selectDatas[1]._tabActive}">
                            <dl class="layui-anim layui-anim-upbit layui-zq-select-dl"  style="display: block">
                                <dd v-for="item in dataMap[1]" v-bind:key="item.id+item.text" v-text="item.title" @click.stop="setSelectAndloadChildren(item, 1)" :class="{'layui-this': item._selected}"></dd>
                            </dl>
                        </div>
                        <div class="layui-tab-item" :class="{'layui-show': selectDatas[2] && selectDatas[2]._tabActive}">
                            <dl class="layui-anim layui-anim-upbit layui-zq-select-dl"  style="display: block">
                                <dd v-for="item in dataMap[2]" v-bind:key="item.id+item.text" v-text="item.title" @click.stop="setSelectAndloadChildren(item, 2)" :class="{'layui-this': item._selected}"></dd>
                            </dl>
                        </div>
                        <div class="layui-tab-item" :class="{'layui-show': selectDatas[3] && selectDatas[3]._tabActive}">
                            <dl class="layui-anim layui-anim-upbit layui-zq-select-dl"  style="display: block">
                                <dd v-for="item in dataMap[3]" v-bind:key="item.id+item.text" v-text="item.title" @click.stop="setSelectAndloadChildren(item, 3)" :class="{'layui-this': item._selected}"></dd>
                            </dl>
                        </div>
                        <div class="layui-tab-item" :class="{'layui-show': selectDatas[4] && selectDatas[4]._tabActive}">
                            <dl class="layui-anim layui-anim-upbit layui-zq-select-dl"  style="display: block">
                                <dd v-for="item in dataMap[4]" v-bind:key="item.id+item.text" v-text="item.title" @click.stop="setSelectAndloadChildren(item, 4)" :class="{'layui-this': item._selected}"></dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </dl>
        </div>
     </span>
</template>

<script>
import region from '../../support/area.json'

// 注意看模板，最多支持级联到5级
export default {
    name: 'LayuiZqSelect',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'layui-ZqSelect-' + window.uuid();
            },
        },
        _model: {
            default: null,
            required: false
        },
        textField: {
            default: 'text',
            type: String
        },
        valueField: {
            default: 'value',
            type: String
        },
        idField: {
            default: '',
            type: String
        },
        parentField: {
            default: '',
            type: String
        },
        jbField: {
            default: '',
            type: String
        },
        tableName: {
            default: '',
            type: String
        },
        selectFields: {
            default: '',
            type: String
        },
        condition: {
            default: () => {
                return {}
            },
            type: Object
        },
        sort: {
            type: Array,
            default: () => {
                return []
            }
        },
        maxWidth: {
            type: Number,
            default: 0
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        // 树加载到几级，主要是用来防止点击最后一层的时候还会去加载
        maxLoadLevel: {
            type: Number,
            required: true,
            default: 3,
        },
        placeholder: {
            default: '请选择政区',
            type: String
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data () {
        return {
            area: region,
            id : null,
            el : null,
            zqSelectText: '',
            zqSelectShow: false,
            selectDatas: this.buildSelectData(),
            data: [],
            dataMap: {0:[],1:[],2:[],3:[],4:[]},
        }
    },

    mounted(){
        var that = this;
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        element.attr("id", this.id);
        this.loadFirst();
        //绑定关闭控件事件
        $(document).on('click', function(e){
            if($(e.target).parents("#"+id).length  == 1){
                return;
            }
            element.find(".zqdrop").hide();
            that.$nextTick(()=> {
                that.zqSelectShow = false;
            });
        })
    },
    methods: {
       setActiveTab(tab){
           this.selectDatas.forEach((item)=>{
               item._tabActive = false;
           });
           tab._tabActive = true;
       },
       getSelectDatas(){
           return this.selectDatas;
       },
       /**
        * 初始化数据
        */
       loadFirst(){
            this.data = [];
            this.area.forEach((item) => {
              this.data.push(this.buildTreeData(item))
            })
            this.dataMap[0] = this.data;
            this.firstLoaded = true;
       },
       /**
        * 设置选中渲染下一个区域
        */
       setSelectAndloadChildren(parent, idx){
            this.selectDatas[idx] = parent;
            this.dataMap[idx].forEach((item)=> {
                //取消当前层级其他item的激活状态
                item._selected = false;
            });
            parent._selected = true;
            this.selectDatas = this.buildSelectData(idx + 1);
            this.buildZqSelectText();
            this.buildModel();
            if(idx + 1 ==  this.maxLoadLevel){
                parent._tabActive = true;
                this.zqSelectShow = false;//选择最后节点后关闭
                return;
            }
            if(parent.childLoad){
                this.setActiveTab(this.selectDatas[idx + 1]);
                this.dataMap[idx + 1] = parent.children;
                return;
            }
            parent.children = [];
            parent._data.child.forEach((item)=>{
              parent.children.push(this.buildTreeData(item));
            });
            this.dataMap[idx + 1] = parent.children;
            this.setActiveTab(this.selectDatas[idx + 1]);
       },
       checkSelectDataIsLoad(idx){
           var current = this.selectDatas[idx];
           var parent = this.selectDatas[idx - 1];
            if(parent){
                this.dataMap[idx] = parent.children;
            }
       },
       /**
        * 新建下一个区域的标题
        */
       buildSelectData(start){
            start = start ? start : 0;
            if(start == this.maxLoadLevel) {
                return this.selectDatas;
            }
            this.selectDatas = this.selectDatas ? this.selectDatas :[];
            this.selectDatas.length = start + 1;
            var emptyActiveSelect = { title: '请选择',text: '请选择', _tabActive: true};
            this.selectDatas[start] = emptyActiveSelect;
            return this.selectDatas;
       },
       /**
        * 处理选中的值
        */
       buildZqSelectText(){
           var textArr = [];
           this.selectDatas.forEach((e)=>{
               if(e.id){
                   textArr.push(e.text);
               }
           });
           this.zqSelectText = textArr.join("-");
       },
       /**
        * v-model的返回值
        */
       buildModel(){
           var valueArr = []
           this.selectDatas.forEach((e)=>{
               if(e.id){
                   valueArr.push(e.id);
               }
           });
           this.ui_update = true;
           this.$emit('selectChange',this.selectDatas);
           this.$emit('_modelEvent', valueArr.join(","));
       },
       /**
        * 构造数据
        */
       buildTreeData(item){
            var treeData = {
                id: item.id,
                title: item.text,
                value: item.text,
                text: item.text,
                // _pid: item[this.parentField],
                _data: item,
                children: item.child,
                _selected: false,
                _tabActive: false,
                childLoad : false,
            }
            return treeData;
      },
      clearWithModel(){
          this.clear();
          this.ui_update = true;
          this.$emit('_modelEvent', '');
      },
      clear(){
           this.zqSelectText = '';
           this.zqSelectShow = false;
           this.selectDatas = this.buildSelectData();
           this._clear(this.data);
      },
      _clear(data){
          for(var i = 0 ; i < data.length; i++){
               var item = data[i];
               item._selected = false;
               item._tabActive = false;
               if(item.children && item.children.length > 0) {
                   this._clear(item.children);
               }
           }
      },
      findDataById(id){
          var result = [];
          this._findDataById(id, this.data,result);
          return result[0];
      },
      _findDataById(id, dataset, result){
          for(var i = 0 ; i < dataset.length; i++){
               var item = dataset[i];
               if(item.id == id) {
                   result.push(item);
                   break;
               }
               if(item.children.length > 0 && result.length != 1) {
                   this._findDataById(id, item.children, result);
               }
           }
      },
      handleModelChange(){
        if(this.ui_update){
            this.ui_update = false;
            return;
        }
        this.clear();
        if(this._model) {
            let values = this._model.split(',');
            //检查数据格式，要求必须是逗号分割，并且第一个不能为空
            for(var i = 0 ; i < values.length; i++) {
                if(!values[i] && i == 0) {
                    return;
                }
            }
            var eachDatas = this.data;
            this.selectDatas = [];
            for(var i = 0 ; i < values.length; i++) {
                var value = values[i];
                if(value) {
                    var targetData = eachDatas.find(item => item.id === value);
                    if(targetData) {
                        this.selectDatas[i]= targetData;
                        targetData.children = [];
                        if(targetData._data && targetData._data.child){
                            targetData._data.child.forEach(item => targetData.children.push(this.buildTreeData(item)));
                        } else if (targetData.child){
                            targetData.child.forEach(item => targetData.children.push(this.buildTreeData(item)));
                        }
                        eachDatas = targetData.children;
                    }
                }
            }
            if(this.selectDatas.length > 0) {
                this.selectDatas.forEach((e)=>{
                    e._tabActive = false;
                    e._selected = true;
                });
                this.selectDatas[0]._tabActive = true;
            }
             this.buildZqSelectText();
        }
      },
    },
    watch:{
      _model(values){
        if(this.firstLoaded) {
           this.handleModelChange();
        }
      },
    }
  }

</script>
<style scoped>
    .layui-zq-select-dl{
        position: initial;
        padding: initial;
        box-shadow: initial;
        border: initial;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/LayuiZqSelect.vue